"use client";

import Header from '@/components/Header';
import HeaderContent from '@/components/HeaderContent';
import Footer from '@/components/Footer';
import Bottom from '@/components/Bottom';
import About from '@/components/About';
import HeyHo from '@/components/HeyHo';

type HomePageProps = {
  aboutContent: string;
  locale: string;
  educationComponent?: React.ReactNode; // Server-rendered Education component
  portfolioComponent?: React.ReactNode; // Server-rendered Portfolio component
  experienceComponent?: React.ReactNode; // Server-rendered Experience component
  children?: React.ReactNode; // For server components injected from parent
};

/**
 * Client component that handles interactive parts of the homepage
 * while using server-rendered content
 */
export default function HomePage({ aboutContent, educationComponent, portfolioComponent, experienceComponent, children }: HomePageProps) {
  return (
    <div className="font-[family-name:var(--font-geist-sans)] cursor-default">
      {/* Navigation Header */}
      <Header />
      
      {/* Hero Section */}
      <HeaderContent />
      
      {/* About Section with pre-rendered content */}
      <About preRenderedContent={aboutContent} />

      {/* HeyHo Ventures Banner */}
      <HeyHo />

      {/* Spotlight Section - Passed from server component */}
      {children}

      {/* Portfolio Section - Server-rendered */}
      {portfolioComponent}

      {/* Experience Section - Server-rendered */}
      {experienceComponent}

      {/* Education Section - Server-rendered */}
      {educationComponent}

      {/* Main Footer */}
      <Footer />
      
      {/* Copyright and Legal Links */}
      <Bottom />
    </div>
  );
}